import * as L from 'leaflet';
// Assign Leaflet to the global scope so CommonJS plugins (e.g. leaflet.markercluster)
// that rely on an implicit global `L` in their UMD factory can initialise correctly
// in optimised/chunk-split builds (dev, staging, production).
// In local dev the module scope coincidentally exposes L; in deployed builds it does not.
// eslint-disable-next-line @typescript-eslint/no-explicit-any
(window as any).L = L;
